<template>
  <div v-if="distribution && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="distribution" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Distributions from "@/api/distributions";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";
import makeData from "./makeData";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    distribution: null,
  }),

  computed: {
    ...mapState(["accountUser","settings"]),
  },

  mounted() {
    PrintTemplates.fetchOne("distribution").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          // formater.page_header_left = [];
          // formater.headers = [];
          // formater.title = null;
          // formater.settings.table_head_repetitive = false;
          // formater.settings.hide_page_counter = true;
          // formater.expand_columns = formater.expand_columns_bak; //.splice(0, 1);
          // formater.group_column = formater.group_column_bak;
          // formater.group_sum_columns = formater.group_sum_columns_bak; //.splice(0, 1);
          // formater.columns = formater.columns.splice(0, 7);
          // formater.sum_columns = [];
          this.formater = formater;
          //获取单据详情
          Distributions.distributionPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                var distribution = response.data.distribution;
                distribution = makeData.processDetails(distribution);
                distribution.order.shop = this.$printUtils.addCitiesName(
                  distribution.order.shop
                );
                distribution.distribution_details.map((detail) => {
                  detail.print_date = new Date().toISOString().substr(0, 10);
                  return detail;
                });
                this.distribution = {
                  distribution: distribution,
                  order: distribution.order,
                  order_address: response.data.order_address,
                  print_date: new Date().toISOString().substr(0, 10),
                  printDateMinutes: this.$datetimeUtils.formatDateMinutes(
                    new Date()
                  ),
                  accountUserName: this.accountUser.name,
                  printPayQrCode: this.settings.print_pay_qr_code,
                };
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>